import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css'; // Import global or page-specific CSS

const NotFound = () => {
    return (
        <div className="notfound-container">
            <h1 className="notfound-title">404 - Page Not Found</h1>
            <p className="notfound-message">
                Oops! The page you are looking for does not exist.
            </p>
            <Link to="/" className="notfound-link">
                <button className="notfound-button">Go Back Home</button>
            </Link>
        </div>
    );
};

export default NotFound;